export default function Footer() {
  return (
    <footer className="bg-blue-600 text-white text-center py-4 mt-10">
      <p className="text-sm">
        © {new Date().getFullYear()} FamHealth — Empowering Family Health 💙
      </p>
    </footer>
  );
}
